import gql from 'graphql-tag';
import { Fragments } from '@shared/api';

export const chatThread = gql`
  query CardChatThreadQuery($id: UUID!) {
    thread: getThread(id: $id) {
      ...Thread
    }
  }

  ${Fragments.thread.thread}
`;

export const listEntityAuditTrailEvents = gql`
  query ListEntityAuditTrailEventsQuery($input: ListEntityAuditTrailEventsInput!) {
    trail: listEntityAuditTrailEvents(input: $input) {
      events {
        id
        timestamp
        userId
        originUserId
        workflowTemplateId
        cardId
        descendantCardId
        descendantWorkflowTemplateId
        entries {
          id
          componentId
          componentType
          change {
            ...AnyComponentDataChange
          }
        }
      }
      refs {
        ...EntityRefs
      }
      nextCursor
    }
  }

  ${Fragments.entity.EntityRefs}
  ${Fragments.card.change}
`;
